import Settings from '../domain/Settings';
import {getSlot} from './slotManager';
import {getCurrentBreakpoint} from './breakpoints';
import pubsub from '../utils/pubsub';

type HeavyAdLog = {
	profile: string,
	creativeId: string,
	slotName: string,
	placement: string
};

export type HeavyAdData = {
	creativeId: string,
	slot: string,
}

let profile: string;

export function init() {
	const settings = Settings.getInstance();

	profile = settings.debugInfo?.profile;

	if (settings.features?.heavyAdTracking && typeof window.ReportingObserver !== 'undefined') {
		pubsub.subscribe('heavyAdReporting', _sendLogs);
	}
}

function _sendLogs(heavyAdData: HeavyAdData) {
	const placement = getSlot(heavyAdData?.slot)?.placement,
		heavyAdLog: HeavyAdLog = {
			'profile': profile ?? window.location.hostname,
			'creativeId': heavyAdData?.creativeId,
			'slotName': heavyAdData?.slot,
			'placement': typeof placement === 'string' ? placement : placement[getCurrentBreakpoint()]
		};

	navigator.sendBeacon(
		`https://advertising-heavy-ad-tracking.target.dpgmedia.cloud/heavy-ad-intervention`,
		JSON.stringify(heavyAdLog)
	);
}
